import PropTypes from 'prop-types';

const displayName = 'FormClient';
const propTypes = {};
const defaultProps = {};

export default { displayName, propTypes, defaultProps };
